import React, { Component } from 'react';
import Card from 'react-bootstrap/Card';
const $ = require('jquery');
// $.DataTable = require('datatables.net');
// require('datatables.net-responsive');
// import 'datatables.net-dt/css/jquery.dataTables.min.css';
// require('datatables.net-buttons/js/dataTables.buttons.min');
const jzip = require('jzip');
// require('datatables.net-buttons/js/buttons.html5.min');
// import 'datatables.net-buttons-dt/css/buttons.dataTables.css';
import Select from 'react-select';
import { DatePicker } from 'react-tempusdominus-bootstrap';
import { Button } from 'react-bootstrap';
import moment from 'moment'; // ✅ เพิ่ม moment.js เพื่อจัดการวันที่
import { toast } from 'react-toastify';


window.JSZip = jzip;
const id = 'id' + Math.random().toString(16).slice(2);

const columns = [
  {
    title: 'DATE_INSERT',
    data: 'DATE_INSERT'
  },
  {
    title: '#',
    data: 'ROW_NO'
  },
  {
    title: 'VIEW',
    data: 'SHOP_ID',
    render: function (data, type, row) {
      // console.log('Render View:', data); // ดูว่ามีค่าหรือไม่
      if (type === 'display') {
        return `
          <a class="btn btn-outline-secondary btn-sm" id="${row.SHOP_ID}_view">
            <i class="fas fa-search"></i>
          </a>`;
      }
      return data;
    }
  },
  {
    title: 'PRINT',
    data: 'PRINT_URL',
    render: function (data, type, row) {
      // console.log('Render View:', data, 'Status:', row.STATUS);
      if (type === 'display') {
        if (row.STATUS === 'RJ') return ''; // กรณีเป็น 'RJ' ไม่ต้องแสดงอะไรเลย

        if (row.STATUS === 'AP' || row.STATUS === 'WA') {
          return `
                <a class="btn btn-outline-success btn-sm" id="${row.SHOP_ID}_pnt" target="_blank" href="${data}">
                    <i class="fas fa-print"></i>
                </a>`;
        }
      }
      return data;
    }
  },
  {
    title: 'STATUS',
    data: 'STATUS',
    render: function (data, type, row) {
      if (type === 'display') {
        if (row.STATUS === '') {
          return `<input class="btn btn-primary btn-xs m-1" type="button" value="on process" disabled>`;
        }
        if (row.STATUS === 'AP') {
          return `<input class="btn btn-success btn-xs m-1" type="button" value="complete" disabled>`;
        }
        if (row.STATUS === 'WA') {
          return `<input class="btn btn-warning btn-xs m-1" type="button" value="waiting" disabled>`;
        }
        if (row.STATUS === 'RJ') {
          return `<input class="btn btn-danger btn-xs m-1" type="button" value="rejected" disabled>`;
        }
      }
      return data;
    }
  },
  {
    title: 'SHOP_ID',
    data: 'SHOP_ID',
  },
  {
    title: 'รหัสพนักงานCD',
    data: 'BY',
  },
  {
    title: 'ชื่อ CD',
    data: 'BY_NAME',

  },
  {
    title: 'ชื่อจุดติดตั้ง/ชื่อร้านค้า',
    data: 'SHOP_NAME_TH',

  },
  {
    title: 'ผู้กระทำการแทน',
    data: 'CONTACT_NAME_TH',

  },
  {
    title: 'ที่อยู่จุดติดตั้ง',
    data: 'ADDRESS',
  },
  {
    title: 'ที่อยู่ตามบัตรประชาชน/ภ.พ.20',
    data: 'ADDRESS_TAX',
  },
  {
    title: 'ชื่อนิติบุคคล/ชื่อบุคคล',
    data: 'SHOP_TAX_NAME_TH',

  },
  {
    title: 'เลขผู้เสียภาษี/เลขบัตรประชาชน',
    data: 'ID_TAX',

  },
  {
    title: 'เบอร์โทร',
    data: 'MOBILE',

  },
  {
    title: 'GPS',
    data: 'GPS',

  },
  {
    title: 'วันที่เริ่มต้นสัญญา',
    data: 'DATE_START',
    render: function (data) {
      return data ? moment(data).format("YYYY-MM-DD") : '-';
    }
  },
  {
    title: 'วันที่สิ้นสุดสัญญา',
    data: 'DATE_END',
    render: function (data) {
      return data ? moment(data).format("YYYY-MM-DD") : '-';
    }
  },
  {
    title: 'เลขที่บัญชีธนาคาร',
    data: 'ACC_ID',

  },
  {
    title: 'เลขที่ใบสัญญา',
    data: 'CONTRACT_NO',

  },
  {
    title: 'อีเมล์',
    data: 'EMAIL',

  },
  {
    title: 'ธนาคาร',
    data: 'BANK_NAME',

  },
  {
    title: 'MSD',
    data: 'MSD_NAME',

  },
  {
    title: 'ลิงค์เอกสาร',
    data: 'SAVE_URL'
  },
  {
    title: 'ผลตอบแทน',
    data: 'CAL_TYPE_NAME'
  },
  {
    title: 'ชื่อผู้ทำการอนุมัต',
    data: 'STATUS_NAME'
  },
  {
    title: 'วันที่การอนุมัติ',
    data: 'DATE_APVED',
    render: function (data) {
      return data ? moment(data).format("YYYY-MM-DD") : '-';
    }
  }
];

// function reloadTableData(items, page, filter) {
//   console.log('reload: ' + items.length);
//   console.log('page: ' + page);
//   const table = $(`#${0}`).DataTable();
//   //   const table = $(`table.example`).DataTable();
//   table.clear();
//   table.rows.add(items);
//   table.draw();
//   console.log('filter: ' + filter);
//   table.search(filter);
//   table.page(page).draw('page');
//   setTimeout(function () {
//     if (table) {
//       table.columns.adjust();
//     }
//   }, 50);
// }

function reloadTableData(items, page, filter) {
  console.log('reload: ' + items.length);
  console.log('page: ' + page);
  const $table = $(`#${0}`);
  if ($table.length && $.fn.dataTable.isDataTable($table)) {
    const table = $table.DataTable();
    table.clear();

    table.rows.add(items);
    table.draw();
    table.search(filter);
    table.page(page).draw('page');
    
    setTimeout(function () {
      // เช็คว่า table element ยังอยู่ใน DOM ก่อน adjust
      if ($table.length && document.body.contains($table[0])) {
        table.columns.adjust();
      }
    }, 50);
  }
}

function updateTable(items, page) {
  console.log('update: ' + items.length);
  const table = $(`#${0}`).DataTable();
  let dataChanged = false;
  table.rows().every(function () {
    const oldNameData = this.data();
    const newNameData = items.find((item) => {
      return item.SHOP_ID === oldNameData.SHOP_ID;
    });

    if (oldNameData.lastUpdate !== newNameData.lastUpdate) {
      dataChanged = true;
      this.data(newNameData);
    }
    return true;
  });

  console.log(dataChanged);
  if (dataChanged) {
    //table.draw();
    table.page(page).draw('page');
  }
}

function showAll() {
  console.log('show');
  var column;

  for (let index = 0; index < 27; index++) {
    column = $(`#${0}`).DataTable().column(index);
    column.visible(true);
  }
}

function hideCols(show) {
  console.log('hide');
  var column;

  for (let index = 0; index < show.length; index++) {
    const element = show[index];
    console.log(element);
    column = $(`#${0}`).DataTable().column(element);
    column.visible(false);
  }
}

function sortCol(col) {
  const table = $(`#${0}`).DataTable();
  // table.order( [[col, 'asc']])
  // table.sortable.sortColumn(col);
  table.order([col, 'asc']).draw();
}

class TableMyshopAccountant extends Component {
  constructor(props) {
    super(props);
    this.state = {
      statusOptions: [
        { value: '', label: ' แสดงทั้งหมด (All)', selected: false },
        { value: 'AP', label: ' อนุมัติ (Approved)', selected: false },
        { value: 'WA', label: ' รออนุมัติ (Waiting)', selected: false },
        { value: 'RJ', label: ' ไม่อนุมัติ (Rejected)', selected: false },
      ],
      approvalReport: [
        // { value: 'all', label: ' รายการทั้งหมด (All)', selected: false },
        { value: 'monthly', label: ' Monthly Report ', selected: false },
        { value: 'monthly2', label: ' Monthly Report (VIEW PRINT) ', selected: false },
      ],

    };
    this.tableRef = React.createRef();
  }

  componentDidMount() {

    const table = $(`#${0}`).DataTable({
      data: this.props.items,
      dom: 'Bfrtip',
      columns,
      searching: true,
      order: [[0, 'desc']], //1
      // columnDefs: [{ target: 0, visible: false }, { target: 23, visible: false },
      //              { target: 24, visible: false }, { target: 25, visible: false }, { target: 26, visible: false }],
      paging: true,
      ordering: true,
      autoWidth: true,
      bDestroy: true,
      pageLength: 10,
      scrollX: true,
      buttons: [
        'copy',
        {
          extend: 'csv',
          title: `data_report_csv_${Date.now()}`
        },
        {
          extend: 'excelHtml5',
          title: `data_report_excel_${Date.now()}`
        }
      ],
      search: {
        search: this.props.filter
      }
    });

    // Event Listener สำหรับปุ่ม View
    $(`#${0} tbody`).on('click', 'a', (event) => {
      var $this = $(event.currentTarget);
      var data = table.row($this.parents('tr')).data();
      if ($this.attr('id').split('_')[1] === 'view') {
        this.props.onToggle(data); // ส่งข้อมูลไปที่ฟังก์ชัน onToggle
      }
    });

    // Event Listener สำหรับปุ่มอื่น ๆ (ถ้าจำเป็น เช่น Print, QR)
    $(`#${0} tbody`).on('click', 'a', (event) => {
      const $this = $(event.currentTarget);
      const data = table.row($this.parents('tr')).data();
      if ($this.attr('id').includes('_print')) {
        console.log('Print Clicked:', data); // Debug
        this.props.onPrintToggle(data); // เรียกฟังก์ชัน Print
      } else if ($this.attr('id').includes('_qr')) {
        console.log('QR Clicked:', data); // Debug
        this.props.onQrToggle(data); // เรียกฟังก์ชัน QR
      }
    });

    table.on('page', (event) => {
      const info = table.page.info();
      this.props.onPageChange(info.page); // อัปเดตเพจ
    });

    table.on('search.dt', (event) => {
      console.log(table.search());
      // if (this.props.onTest){
      //   this.props.onTest();
      // }
      this.props.setFilter(table.search());
      // $('#filterInfo').html('Currently applied global search: ' + table.search());
    });
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.items !== this.props.items || prevState.selectedStatus !== this.state.selectedStatus) {
      this.filterTableData();
    }
  }

  componentWillUnmount() {
    $(`#${0}`).DataTable().destroy(true);
  }

  shouldComponentUpdate(nextProps) {
    // if (nextProps.items.length !== this.props.items.length) {
    // reloadTableData(nextProps.items, nextProps.page);
    console.log("HERE");
    console.log(nextProps.selectedStatus.approvalReport);

    if (nextProps.selectedStatus.approvalReport !== this.props.selectedStatus.approvalReport) {
      reloadTableData([], nextProps.page, nextProps.filter);
      if (nextProps.selectedStatus.approvalReport === 'all') {
        showAll();
        hideCols([0, 23, 24, 25, 26]);
      }
      else if (nextProps.selectedStatus.approvalReport === 'monthly2') {
        showAll();
        hideCols([0, 1, 17]);
        sortCol(26);
      } else {
        showAll();
        hideCols([0, 1, 2, 3, 4, 17]);
        sortCol(26);
      }
    } else {
      reloadTableData(nextProps.items, nextProps.page, nextProps.filter);
    }
    return true;
    // } else {
    // updateTable(nextProps.items, nextProps.page);
    // }
    // return true;
  }

  filterTableData() {
    const { selectedStatus } = this.state;
    let filteredData = this.props.items;

    if (selectedStatus !== 'A') {
      filteredData = filteredData.filter((shop) => shop.STATUS === selectedStatus);
    }

    const table = $(this.tableRef.current).DataTable();
    table.clear();
    table.rows.add(filteredData);
    table.draw();
  }


  handleStatusChange = (selectedOption) => {
    const selectedValue = selectedOption ? selectedOption.value : '';
    this.props.setSelectedStatus((prev) => (
      { ...prev, status: selectedValue }
    ));
  };

  // handleApprovalReportChange = (selectedOption) => {
  //   //const firstDate =
  //   //const lastDate =
  //   const selectedValue = selectedOption ? selectedOption.value : 'all';
  //   this.props.setSelectedStatus((prev) => (
  //     { ...prev, approvalReport: selectedValue, start : firstDate }
  //   ));
  //   if(selectedOption.value === ""){

  //   }else{

  //   }
  // };

  handleApprovalReportChange = (selectedOption) => {
    const selectedValue = selectedOption ? selectedOption.value : 'all';

    let firstDate = null;
    let lastDate = null;

    if (selectedValue == 'monthly') {
      const currentDate = new Date();
      firstDate = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1); // วันที่ 1 ของเดือน
      lastDate = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 0); // วันสุดท้ายของเดือน
    }

    this.props.setSelectedStatus((prev) => ({
      ...prev,
      approvalReport: selectedValue,
      start: firstDate ? firstDate.toLocaleDateString('en-CA') : prev.start,
      end: lastDate ? lastDate.toLocaleDateString('en-CA') : prev.end
    }));
  };


  updateDataTable(data) {
    if ($.fn.DataTable.isDataTable(this.tableRef.current)) {
      const table = $(this.tableRef.current).DataTable();
      table.clear();
      table.rows.add(data);
      table.draw();
    }
  }

  handleDateChange = (type, value) => {
    if (value) {
      // const formattedDate = moment(value).format('YYYY-MM-DD'); // ✅ ใช้ moment() แปลงเป็น string
      const formattedDate = moment(value).local().format('YYYY-MM-DD'); // ✅ ใช้ .local()
      //localStorage.setItem(type, formattedDate); // ✅ บันทึกลง localStorage
      this.setState({ [type]: moment(value) }); // ✅ เก็บใน state เป็น moment object
    }
  };

  handleFetchData = () => {
    const { start, end, status, searchs, approvalReport } = this.props.selectedStatus;

    if ((!start || !end) && status !== "WA") {
      toast.error("กรุณาเลือกวันที่เริ่มต้นสัญญาและสิ้นสุดสัญญาก่อนดึงข้อมูล");
      return;
    }

    this.props.loadData(true);
  };

  handleKeyDown = (event) => {
    if (event.key === "Enter") {
      event.preventDefault();  // ✅ ป้องกันฟอร์มรีเฟรช
      this.handleFetchData();
    }
  };


  render() {
    return (
      <div>
        {/* Header - Dropdown ตัวเลือกกรอง STATUS */}
        <Card className="card-warning">
          <div className={this.props.isAdmin ? 'd-none' : 'overlay dark'}>
            <span style={{ color: 'white', fontSize: 30 }}>ADMIN ONLY</span>
          </div>
          <Card.Header>
            <div className='row'>
              {/* <div className='col-2'>รายการทั้งหมด</div> */}
              <div className='col-12'>
                <div className='row'>
                  {/* <div className="col-md-3">
                    <input
                      type="text"
                      className="form-control"
                      placeholder="ชื่อร้านค้า, เลขประจำตัวผู้เสียภาษี, ผู้กระทำการแทน"
                      value={this.props.selectedStatus.searchs || ``}
                      onChange={(e) => {
                        this.props.setSelectedStatus((prev) => (
                          { ...prev, searchs: e.target.value }
                        ));
                      }}
                      onKeyDown={this.handleKeyDown}
                    />
                  </div> */}

                  {/* DatePicker สำหรับวันที่เริ่มต้น */}
                  <DatePicker
                    className="col-md-3"
                    date={this.props.selectedStatus.start}
                    format="YYYY-MM-DD"
                    onChange={(e) => {
                      if (e.date) {
                        const startDate = moment(e.date).startOf("month"); // วันที่ 1 ของเดือน
                        const endDate = moment(e.date).endOf("month"); // วันสุดท้ายของเดือน

                        this.props.setSelectedStatus((prev) => ({
                          ...prev,
                          start: startDate,
                          end: endDate,
                        }));
                      }
                    }}
                  />

                  {/* DatePicker สำหรับวันที่สิ้นสุด */}
                  <DatePicker
                    className="col-md-3"
                    date={this.props.selectedStatus.end}
                    format="YYYY-MM-DD"
                    onChange={(e) => {
                      if (e.date) {
                        const startDate = moment(e.date).startOf("month"); // วันที่ 1 ของเดือน
                        const endDate = moment(e.date).endOf("month"); // วันสุดท้ายของเดือน

                        this.props.setSelectedStatus((prev) => ({
                          ...prev,
                          start: startDate,
                          end: endDate,
                        }));
                      }
                    }}
                  />

                  {/* ตัวเลือกสถานะ */}
                  {/* <Select
                    className="col-md-2"
                    defaultValue={this.state.statusOptions.find((e) => (e.value === this.props.selectedStatus.status))}
                    // value={this.state.statusOptions.find((e) => (e.value === this.state.selectedStatus) || (e.value === this.props.selectedStatus))}
                    options={this.state.statusOptions}
                    onChange={this.handleStatusChange}
                  /> */}

                  <Select
                    className="col-md-3"
                    value={this.state.approvalReport.find((e) => e.value === this.props.selectedStatus.approvalReport)}
                    options={this.state.approvalReport}
                    onChange={this.handleApprovalReportChange} // ✅ ใช้ฟังก์ชันที่ถูกต้อง
                  />


                  {/* ปุ่มดึงข้อมูล */}
                  <div>
                    <Button className="btn" onClick={this.handleFetchData}>
                      ดึงข้อมูล
                    </Button>
                  </div>
                </div>
              </div>

            </div>

          </Card.Header>
          <Card.Body>
            <table
              ref="main"
              className="display nowrap example"
              id={0}
              style={{ width: '100%' }}
            />
          </Card.Body>
        </Card>
      </div >
    );
  }
}
export default TableMyshopAccountant;
